export default __webpack_public_path__ + "media/images/icons/meh-regular-0b14b843aa681e803cb6cb40a9317e66.svg";